var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullscreenClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89 13.88L2.89 16.66L6.36 16.66L0 23.02L1.96 24.98L8.44 18.51L8.44 22.21L11.22 22.21L11.22 13.88L8.44 13.88L2.89 13.88ZM25.25 1.96L23.28 0L16.8 6.48L16.8 2.77L14.03 2.77L14.03 11.1L16.8 11.1L22.36 11.1L22.36 8.33L18.88 8.33L25.25 1.96Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenClose);
export default __webpack_public_path__ + "static/media/fullscreen-close.547fca39.svg";
export { ForwardRef as ReactComponent };